export default Object.freeze({
  none: '',
  comma: '0,0',
  currency: '$0,0.00',
})



// WEBPACK FOOTER //
// ./src/models/NumberFormat.js